import { render, staticRenderFns } from "./JobOffers.vue?vue&type=template&id=7466b6d1"
import script from "./JobOffers.vue?vue&type=script&lang=ts"
export * from "./JobOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports